<div class="container-unipay" [class]="className">
  <ng-content></ng-content>
</div>